import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

const findItemIndex = (state, action) =>
  state.findIndex((item) => item.productId === action.payload.productId);


//it creates new action action types and they are added to extraReducers
export const fetchCartItemsData = createAsyncThunk("cart/fetchCartItems", async () => {
  try {
    const response = await fetch("https://fakestoreapi.com/carts/5");
    return response.json();
  } catch (err) {
    throw err;
  }
});

const slice = createSlice({
  name: "cart",
  initialState: {
    loading: false,
    list: [],
    error: "",
  },
  reducers: {
    // fetchCartItems(state) {
    //   state.loading = true;
    // },
    // loadCartitems(state, action) {
    //   state.loading = false;
    //   state.list = action.payload.products;
    // },
    // fetchCartItemsError(state, action) {
    //   state.loading = false;
    //   state.error = action.payload || "Something went wrong.";
    // },
    addCartItem(state, action) {
      const existingIndex = findItemIndex(state.list, action);
      if (existingIndex !== -1) {
        state.list[existingIndex].quantity += 1;
      } else {
        state.list.push({ ...action.payload, quantity: 1 });
      }
    },
    removeCartItem(state, action) {
      const existingIndex = findItemIndex(state.list, action);
      state.list.splice(existingIndex, 1);
    },
    increaseCartItemQuantity(state, action) {
      const existingIndex = findItemIndex(state.list, action);
      state.list[existingIndex].quantity += 1;
    },
    decreaseCartItemQuantity(state, action) {
      const existingIndex = findItemIndex(state.list, action);
      state.list[existingIndex].quantity -= 1;
      if (state.list[existingIndex].quantity === 0) {
        state.list.splice(existingIndex, 1);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCartItemsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCartItemsData.fulfilled, (state, action) => {
        // here action is returned response.json from above async function
        state.loading = false;
        state.list = action.payload.products;
      })
      .addCase(fetchCartItemsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong.";
      });
  },
});

export const getCartItems = ({ products, cartItems }) => {
  return cartItems.list
    .map(({ productId, quantity }) => {
      const cartProduct = products.list.find(
        (product) => product.id === productId
      );
      return { ...cartProduct, quantity };
    })
    .filter(({ title }) => title);
};
export const getAllCartItems = createSelector(getCartItems, (state) => state); // memoizing=> it is necessary because completly new array is returned
export const getCartLoadingState = (state) => state.cartItems.loading;
export const getCartErrorState = (state) => state.cartItems.error;

//thunk action creatorr
// export const fetchCartItemsData = () => (dispatch) => {
//   dispatch(fetchCartItems());
//   fetch("https://fakestoreapi.com/carts/5")
//     .then((res) => {
//       if (!res.ok) {
//         throw new Error("Failed to fetch products. Please try again later.");
//       }
//       return res.json();
//     })
//     .then((data) => {
//       dispatch(loadCartitems(data));
//     })
//     .catch((err) => {
//       dispatch(fetchCartItemsError(err.message));
//     });
// };

export const {
  addCartItem,
  removeCartItem,
  increaseCartItemQuantity,
  decreaseCartItemQuantity,
  // loadCartitems,
  // fetchCartItems,
  // fetchCartItemsError,
} = slice.actions;

export default slice.reducer;
